module.exports = __webpack_public_path__ + "static/media/discord.59bc3df2.svg";